var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebPrTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_5003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.759033 8.64181C0.759033 7.47042 0.982976 6.35645 1.43086 5.2999C1.86726 4.26631 2.48454 3.35044 3.2827 2.55229C4.08085 1.75413 4.99672 1.13685 6.03031 0.700451C7.08686 0.252565 8.20083 0.0286217 9.37222 0.0286217C10.5436 0.0286217 11.6576 0.252565 12.7141 0.700451C13.7477 1.13685 14.6636 1.75413 15.4618 2.55229C16.2599 3.35044 16.8772 4.26631 17.3136 5.2999C17.7615 6.35645 17.9854 7.47042 17.9854 8.64181C17.9854 9.81321 17.7615 10.9272 17.3136 11.9837C16.8772 13.0173 16.2599 13.9332 15.4618 14.7313C14.6636 15.5295 13.7477 16.1468 12.7141 16.5832C11.6576 17.0311 10.5436 17.255 9.37222 17.255C8.20083 17.255 7.08686 17.0311 6.03031 16.5832C4.99672 16.1468 4.08085 15.5295 3.2827 14.7313C2.48454 13.9332 1.86726 13.0173 1.43086 11.9837C0.982976 10.9272 0.759033 9.81321 0.759033 8.64181ZM13.2654 5.74778C13.0931 5.57552 12.8893 5.48939 12.6539 5.48939C12.4184 5.48939 12.2146 5.57552 12.0423 5.74778L8.08025 9.70985L6.70214 8.33174C6.52987 8.15947 6.32603 8.07334 6.0906 8.07334C5.85517 8.07334 5.65133 8.1566 5.47906 8.32312C5.3068 8.48965 5.22067 8.69349 5.22067 8.93466C5.22067 9.17583 5.3068 9.38255 5.47906 9.55481L7.4601 11.5358C7.63236 11.7081 7.83908 11.7942 8.08025 11.7942C8.32142 11.7942 8.52239 11.7081 8.68317 11.5358L13.2654 6.97085C13.4377 6.79859 13.5238 6.59187 13.5238 6.3507C13.5238 6.10954 13.4377 5.90856 13.2654 5.74778Z",
    fill: "#059669"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_5003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7309,
    height: 17.2264,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.506592 17.2554)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebPrTick);
export default __webpack_public_path__ + "static/media/web_PR_tick.fb561da2cb98481886c4b3d62bc6e7ab.svg";
export { ForwardRef as ReactComponent };